import { END_POINT } from "@constants/api.constants";
import { checkForExpiredToken } from "@screens/system/settings/setting-list/setting.list.service";
import { store } from "@src/store";

const {
  INVENTORY_ITEMS_DELETE,
  INVENTORY_ITEMS_LIST,
  INVENTORY_ITEMS_UPLOAD,
  INVENTORY_ITEMS_SAMPLE_DOWNLOAD,
  INVENTORY_ITEMS_SAMPLE_DOWNLOAD_WITHOUT_SPECS,
  MANUFACTURES_LIST,
} = END_POINT;

export const getManufacturesDataApi = async () => {
  return await fetch(MANUFACTURES_LIST, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((response) => {
      // console.log(response.data);
      if (response.status)
        return {
          status: true,
          data: response.data,
        };
      else {
        return { status: false, message: response.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};
export const getDataApi = async ({ orderBy, sortBy, skip, limit, filters }) => {
  return await fetch(
    `${INVENTORY_ITEMS_LIST}?sort_by=${sortBy}&order_by=${orderBy}&skip=${skip}&limit=${limit}${filters}`,
    {
      method: "GET",
      headers: {
        "content-type": "application/json",
        token: store.getState().app?.token,
      },
    }
  )
    .then((res) => res.json())
    .then((response) => {
      console.log(response.data);
      if (response.status)
        return {
          status: true,
          data: response.data.list,
          totalCount: response.data.total_count,
        };
      else {
        checkForExpiredToken(response.message);
        return { status: false, message: response.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const deleteDataApi = async (ids) => {
  return await fetch(INVENTORY_ITEMS_DELETE, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify({ ids }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status)
        return {
          status: true,
          data: data.data.list,
          totalCount: data.data.total_count,
        };
      else {
        checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const readFile = async (payload) => {
  const formData = new FormData();
  formData.append("category_id", payload.category_id);
  formData.append("file", payload.file);

  return await fetch(INVENTORY_ITEMS_UPLOAD, {
    method: "POST",
    headers: {
      // "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: formData,
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) return { status: true, data: data.data };
      else {
        checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const downloadSampleFile = async (payload) => {
  try {
    const response = await fetch(INVENTORY_ITEMS_SAMPLE_DOWNLOAD, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: store.getState().app.token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      return { status: false, message: errorText };
    }

    const blob = await response.blob();
    return { status: true, data: blob };
  } catch (error) {
    return {
      status: false,
      message: "Something went wrong, please try again later.",
      error,
    };
  }
};

export const downloadSampleFileWithoutSpecs = async (payload) => {
  try {
    const response = await fetch(INVENTORY_ITEMS_SAMPLE_DOWNLOAD_WITHOUT_SPECS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: store.getState().app.token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      return { status: false, message: errorText };
    }

    const blob = await response.blob();
    return { status: true, data: blob };
  } catch (error) {
    return {
      status: false,
      message: "Something went wrong, please try again later.",
      error,
    };
  }
};
